import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { Loader2, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Logo } from "@/components/Logo";
import { api, formatApiErrorDetail } from "@/lib/api";

const inputClass = "w-full h-12 px-4 rounded-xl bg-slate-50/60 border border-slate-200 text-slate-900 placeholder:text-slate-400 outline-none focus:bg-white focus:border-slate-400 focus:ring-4 focus:ring-slate-900/5 dark:bg-white/5 dark:border-white/10 dark:text-slate-100";

export default function ResetPassword() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!token) { toast.error("Lien invalide."); return; }
    if (pw !== confirm) { toast.error("Les deux mots de passe ne correspondent pas."); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw, confirm_password: confirm });
      toast.success("Mot de passe réinitialisé. Vous pouvez vous connecter.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-[#FAFAFA] p-4 dark:bg-[#0A0A0A]">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
        className="w-full max-w-md rounded-3xl border border-slate-100 bg-white p-8 shadow-[0_8px_30px_rgb(0,0,0,0.06)] dark:border-white/10 dark:bg-white/[0.04]"
        data-testid="reset-card">
        <div className="mb-6 flex items-center gap-2.5"><Logo size={34} /><span className="text-base font-semibold text-slate-900 dark:text-slate-100">Le Passeport</span></div>
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900 dark:text-slate-100">Nouveau mot de passe</h1>
        <p className="mt-1 mb-5 text-sm text-slate-500">Choisissez un mot de passe (8 caractères min., 1 lettre + 1 chiffre).</p>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <input className={inputClass} type="password" placeholder="Nouveau mot de passe" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password" />
          <input className={inputClass} type="password" placeholder="Confirmer" value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm" />
          <button type="submit" disabled={busy} className="mt-1 flex h-12 w-full items-center justify-center gap-2 rounded-xl bg-slate-900 font-medium text-white transition-transform hover:scale-[0.98] disabled:opacity-60 dark:bg-white dark:text-slate-900" data-testid="reset-submit">
            {busy ? <Loader2 size={20} className="animate-spin" /> : <><KeyRound size={18} /> Réinitialiser</>}
          </button>
        </form>
      </motion.div>
    </div>
  );
}
